/* =============================================
   ICEVLT Theme — Main JavaScript
   ============================================= */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ─── Mobile Nav ─── */
  var menuToggle = $('#menu-toggle');
  var mobileNav = $('#mobile-nav');
  var mobileNavClose = $('#mobile-nav-close');
  var overlay = $('#overlay');

  function openMobileNav() { mobileNav && mobileNav.classList.add('open'); overlay && overlay.classList.add('active'); }
  function closeMobileNav() { mobileNav && mobileNav.classList.remove('open'); overlay && overlay.classList.remove('active'); }

  menuToggle && menuToggle.addEventListener('click', openMobileNav);
  mobileNavClose && mobileNavClose.addEventListener('click', closeMobileNav);

  /* ─── Search Bar ─── */
  var searchToggle = $('#search-toggle');
  var searchBar = $('#search-bar');
  var searchClose = $('#search-close');
  searchToggle && searchToggle.addEventListener('click', function () {
    searchBar && searchBar.classList.toggle('open');
    if (searchBar && searchBar.classList.contains('open')) {
      var inp = $('input', searchBar); inp && inp.focus();
    }
  });
  searchClose && searchClose.addEventListener('click', function () { searchBar && searchBar.classList.remove('open'); });

  /* ─── Cart Drawer ─── */
  var cartDrawer = $('#cart-drawer');
  var cartToggle = $('#cart-toggle');
  var cartDrawerClose = $('#cart-drawer-close');

  function openCart() { cartDrawer && cartDrawer.classList.add('open'); overlay && overlay.classList.add('active'); renderCart(); }
  function closeCart() { cartDrawer && cartDrawer.classList.remove('open'); overlay && overlay.classList.remove('active'); }

  cartToggle && cartToggle.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  cartDrawerClose && cartDrawerClose.addEventListener('click', closeCart);

  overlay && overlay.addEventListener('click', function () { closeMobileNav(); closeCart(); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeMobileNav(); closeCart(); searchBar && searchBar.classList.remove('open'); }
  });

  /* ─── Money formatting ─── */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ─── Cart API ─── */
  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function updateCartCount(count) {
    var el = $('#cart-count');
    if (el) { el.textContent = count; el.setAttribute('data-count', count); }
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    }).then(function (r) { return r.json(); });
  }

  function changeCartLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  var PROTECTION_PRICE = (window.ICEVLT && window.ICEVLT.protectionPrice) || 0;

  function renderCart() {
    fetchCart().then(function (cart) {
      updateCartCount(cart.item_count);
      var itemsEl = $('#cart-items');
      var emptyEl = $('#cart-empty');
      var footerEl = $('#cart-footer');
      var upsellEl = $('#cart-upsell');
      var progressEl = $('#cart-progress');
      var headerCount = $('#cart-header-count');
      if (headerCount) headerCount.textContent = '(' + cart.item_count + ')';
      if (!itemsEl) return;

      if (cart.item_count === 0) {
        itemsEl.innerHTML = '';
        emptyEl && (emptyEl.style.display = 'block');
        footerEl && (footerEl.style.display = 'none');
        upsellEl && (upsellEl.style.display = 'none');
        progressEl && (progressEl.style.display = 'none');
        return;
      }

      emptyEl && (emptyEl.style.display = 'none');
      footerEl && (footerEl.style.display = 'block');
      progressEl && (progressEl.style.display = 'block');

      // Detect protection line item so we exclude it from the "products" list
      var protectionVariantId = (window.ICEVLT && window.ICEVLT.protectionVariantId) || null;
      var protectionLine = null;
      var productItems = [];
      var productsTotal = cart.total_price;
      cart.items.forEach(function (item, i) {
        var isProtection = (protectionVariantId && item.variant_id === protectionVariantId) ||
                           (item.properties && item.properties._shipping_protection);
        if (isProtection) {
          protectionLine = { line: i + 1, item: item };
          productsTotal -= item.final_line_price;
        } else {
          productItems.push({ item: item, line: i + 1 });
        }
      });

      itemsEl.innerHTML = productItems.map(function (row) {
        var item = row.item;
        var line = row.line;
        var variantLine = item.variant_title && item.variant_title !== 'Default Title'
          ? '<p class="cart-drawer-item__variant">' + item.options_with_values.map(function (o) { return o.name + ': ' + o.value; }).join(', ') + '</p>' : '';
        var img = item.image ? item.image.replace(/(\.[^.]+)$/, '_144x144$1') : '';
        return '<div class="cart-drawer-item">' +
          '<img class="cart-drawer-item__img" src="' + img + '" alt="' + item.product_title + '">' +
          '<div>' +
            '<p class="cart-drawer-item__title">' + item.product_title + '</p>' +
            variantLine +
            '<p class="cart-drawer-item__price">' + formatMoney(item.final_price) + '</p>' +
            '<div class="qty-control">' +
              '<button class="qty-btn" data-cart-action="dec" data-line="' + line + '">−</button>' +
              '<input class="qty-input" type="number" value="' + item.quantity + '" min="0" data-line="' + line + '" readonly>' +
              '<button class="qty-btn" data-cart-action="inc" data-line="' + line + '">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="cart-drawer-item__col-right">' +
            '<button class="cart-drawer-item__delete" data-cart-action="remove" data-line="' + line + '" aria-label="Remove">' +
              '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>' +
            '</button>' +
          '</div>' +
        '</div>';
      }).join('');

      // Subtotal = product items only (checkout shows full total)
      var subtotalEl = $('#cart-checkout-total');
      subtotalEl && (subtotalEl.textContent = formatMoney(cart.total_price));

      updateProgress(productsTotal);
      renderUpsell(cart);
      syncProtectionToggle(protectionLine);
    });
  }

  /* ─── Progress bar ─── */
  function updateProgress(total) {
    var el = $('#cart-progress');
    if (!el) return;
    var giftT = parseInt(el.getAttribute('data-gift-threshold'), 10) || 0;
    var shipT = parseInt(el.getAttribute('data-shipping-threshold'), 10) || 0;
    var giftLabel = el.getAttribute('data-gift-label') || 'reward';
    var shipLabel = el.getAttribute('data-shipping-label') || 'free shipping';
    var msg = $('#cart-progress-msg');
    var fill = $('#cart-progress-fill');
    var mGift = $('#milestone-gift');
    var mShip = $('#milestone-shipping');

    // fill relative to the final (shipping) threshold; gift sits at 50%
    var pct = shipT > 0 ? Math.min(100, (total / shipT) * 100) : 0;
    if (fill) fill.style.width = pct + '%';

    mGift && mGift.classList.toggle('reached', total >= giftT);
    mShip && mShip.classList.toggle('reached', total >= shipT);

    if (msg) {
      if (total >= shipT) {
        msg.innerHTML = "You've unlocked <strong>" + shipLabel + "</strong>! 🎉";
      } else if (total >= giftT) {
        msg.innerHTML = "You're " + formatMoney(shipT - total) + " away from <strong>" + shipLabel + "</strong>";
      } else {
        msg.innerHTML = "You're " + formatMoney(giftT - total) + " away from a <strong>" + giftLabel + "</strong>";
      }
    }
  }

  /* ─── Upsell carousel ─── */
  var upsellIndex = 0;
  function renderUpsell(cart) {
    var wrap = $('#cart-upsell');
    var track = $('#upsell-track');
    var products = (window.ICEVLT && window.ICEVLT.upsellProducts) || [];
    if (!wrap || !track || !products.length) { wrap && (wrap.style.display = 'none'); return; }

    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.product_id] = true; });
    var available = products.filter(function (p) { return p.available && !inCart[p.id]; });
    if (!available.length) { wrap.style.display = 'none'; return; }

    wrap.style.display = 'block';
    track.innerHTML = available.map(function (p) {
      var opts = p.variants.map(function (v) {
        return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + v.title + '</option>';
      }).join('');
      var selector = p.variants.length > 1
        ? '<select class="cart-upsell__select">' + opts + '</select>'
        : '<span class="cart-upsell__select" style="display:flex;align-items:center;">' + p.variants[0].title + '</span>';
      var firstVariant = p.variants[0].id;
      return '<div class="cart-upsell__card">' +
        '<img src="' + (p.image || '') + '" alt="' + p.title + '">' +
        '<div>' +
          '<p class="cart-upsell__card-title">' + p.title + '</p>' +
          '<p class="cart-upsell__card-price">' + formatMoney(p.price) + '</p>' +
          '<div class="cart-upsell__card-actions">' +
            selector +
            '<button class="cart-upsell__add" data-upsell-add data-variant="' + firstVariant + '">Add</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');
    upsellIndex = 0;
    moveUpsell(0, available.length);
  }

  function moveUpsell(dir, count) {
    var track = $('#upsell-track');
    if (!track) return;
    var total = count || track.children.length;
    upsellIndex = Math.max(0, Math.min(total - 1, upsellIndex + dir));
    track.style.transform = 'translateX(-' + (upsellIndex * 100) + '%)';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('#upsell-prev')) moveUpsell(-1);
    if (e.target.closest('#upsell-next')) moveUpsell(1);
    var addBtn = e.target.closest('[data-upsell-add]');
    if (addBtn) {
      var card = addBtn.closest('.cart-upsell__card');
      var sel = card ? card.querySelector('select') : null;
      var variantId = sel ? sel.value : addBtn.getAttribute('data-variant');
      addBtn.textContent = 'Adding...';
      addToCart(variantId, 1).then(function () { renderCart(); });
    }
  });
  // keep upsell add button variant synced with its dropdown
  document.addEventListener('change', function (e) {
    if (e.target.matches('.cart-upsell__select')) {
      var btn = e.target.closest('.cart-upsell__card').querySelector('[data-upsell-add]');
      if (btn) btn.setAttribute('data-variant', e.target.value);
    }
  });

  /* ─── Shipping protection ─── */
  function syncProtectionToggle(protectionLine) {
    var toggle = $('#protection-toggle');
    if (!toggle) return;
    toggle.checked = !!protectionLine;
  }

  document.addEventListener('change', function (e) {
    if (e.target.id !== 'protection-toggle') return;
    var toggle = e.target;
    var variantId = window.ICEVLT && window.ICEVLT.protectionVariantId;
    toggle.disabled = true;

    if (!variantId) {
      // No protection product selected in theme settings — fall back to a cart attribute.
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Shipping Protection': toggle.checked ? 'Yes' : '' } })
      }).then(function () { renderCart(); toggle.disabled = false; });
      return;
    }

    if (toggle.checked) {
      // Add the real protection product (qty 1, capped at 1)
      addToCart(variantId, 1).then(function () { renderCart(); toggle.disabled = false; });
    } else {
      // Remove it by setting its quantity to 0
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 0 })
      }).then(function () { renderCart(); toggle.disabled = false; });
    }
  });

  // Cart drawer qty/remove actions (event delegation)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-action]');
    if (!btn) return;
    var action = btn.getAttribute('data-cart-action');
    var line = parseInt(btn.getAttribute('data-line'), 10);
    var input = $('.qty-input[data-line="' + line + '"]', cartDrawer);
    var current = input ? parseInt(input.value, 10) : 1;
    var newQty = current;
    if (action === 'inc') newQty = current + 1;
    else if (action === 'dec') newQty = Math.max(0, current - 1);
    else if (action === 'remove') newQty = 0;
    changeCartLine(line, newQty).then(function () { renderCart(); });
  });

  /* ─── Add to Cart buttons (product cards) ─── */
  $$('.product-card__atc[data-product-id]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var id = btn.getAttribute('data-product-id');
      if (!id) return;
      var original = btn.textContent;
      btn.textContent = 'ADDING...';
      btn.disabled = true;
      addToCart(id, 1).then(function () {
        btn.textContent = 'ADDED ✓';
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1200);
        openCart();
      }).catch(function () {
        btn.textContent = original; btn.disabled = false;
      });
    });
  });

  /* ─── Product Form (PDP) ─── */
  var productForm = $('#product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var variantSelect = $('#variant-select');
      var qtyInput = $('input[name="quantity"]', productForm);
      var variantId = variantSelect ? variantSelect.value : null;
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      var submitBtn = $('#add-to-cart');
      if (!variantId) return;
      var original = submitBtn.textContent;
      submitBtn.textContent = 'ADDING...';
      submitBtn.disabled = true;
      addToCart(variantId, qty).then(function () {
        submitBtn.textContent = 'ADDED ✓';
        setTimeout(function () { submitBtn.textContent = original; submitBtn.disabled = false; }, 1200);
        openCart();
      }).catch(function () {
        submitBtn.textContent = original; submitBtn.disabled = false;
      });
    });
  }

  /* ─── Color name → CSS mapping for swatches ─── */
  var COLOR_MAP = {
    silver: 'linear-gradient(135deg,#e8e8e8,#a8a8a8,#f4f4f4)',
    gold: 'linear-gradient(135deg,#f6e27a,#d4af37,#b8860b)',
    'rose gold': 'linear-gradient(135deg,#f7c1b0,#e0a899,#b76e79)',
    rosegold: 'linear-gradient(135deg,#f7c1b0,#e0a899,#b76e79)',
    pink: '#f4a6c0',
    purple: '#3d1a5b',
    'light blue': '#6db6ea',
    'sky blue': '#6db6ea',
    blue: '#0f2e8c',
    'navy': '#0f2e8c',
    yellow: '#f4d035',
    black: '#111111',
    rainbow: 'linear-gradient(135deg,#ff0080,#ff8c00,#40e0d0,#8a2be2)',
    green: '#2e7d46',
    red: '#c0272d',
    white: '#ffffff'
  };

  $$('.swatch-btn__fill').forEach(function (fill) {
    var name = (fill.getAttribute('data-color') || '').toLowerCase().trim();
    var val = COLOR_MAP[name];
    if (val) fill.style.background = val;
  });

  /* ─── Product Option Buttons (buttons + swatches) ─── */
  var selectedOptions = [];
  function setupOptionBtn(btn) {
    var idx = parseInt(btn.getAttribute('data-option-index'), 10);
    if (btn.classList.contains('active')) selectedOptions[idx] = btn.getAttribute('data-value');
    btn.addEventListener('click', function () {
      $$('[data-option-index="' + idx + '"]').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      selectedOptions[idx] = btn.getAttribute('data-value');
      var label = $('[data-selected-for="' + idx + '"]');
      if (label) label.textContent = btn.getAttribute('data-value');
      updateSelectedVariant();
    });
  }
  $$('.option-btn').forEach(setupOptionBtn);
  $$('.swatch-btn').forEach(setupOptionBtn);

  function updateSelectedVariant() {
    if (!window.ICEVLT || !window.ICEVLT.productVariants) return;
    var variants = window.ICEVLT.productVariants;
    var match = variants.find(function (v) {
      return selectedOptions.every(function (opt, i) {
        return opt == null || v.options[i] === opt;
      });
    });
    var variantSelect = $('#variant-select');
    var addBtn = $('#add-to-cart');
    if (match && variantSelect) {
      variantSelect.value = match.id;
      var priceEl = $('.product-info__price');
      if (priceEl && !priceEl.classList.contains('product-info__price--sale')) {
        priceEl.textContent = formatMoney(match.price);
      }
      if (addBtn) {
        if (match.available) { addBtn.textContent = 'ADD TO CART'; addBtn.disabled = false; }
        else { addBtn.textContent = 'SOLD OUT'; addBtn.disabled = true; }
      }
    }
  }

  /* ─── Product Gallery ─── */
  $$('.product-gallery__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var idx = thumb.getAttribute('data-index');
      $$('.product-gallery__slide').forEach(function (s) { s.classList.toggle('active', s.getAttribute('data-index') === idx); });
      $$('.product-gallery__thumb').forEach(function (t) { t.classList.toggle('active', t === thumb); });
    });
  });

  /* ─── Qty controls (cart page + PDP) ─── */
  $$('.qty-control:not([data-line]) .qty-btn, .qty-control--lg .qty-btn').forEach(function (btn) {
    if (btn.hasAttribute('data-cart-action')) return;
    btn.addEventListener('click', function () {
      var control = btn.closest('.qty-control');
      var input = $('.qty-input', control);
      if (!input) return;
      var val = parseInt(input.value, 10) || 0;
      var action = btn.getAttribute('data-action');
      if (action === 'increase') input.value = val + 1;
      else if (action === 'decrease') input.value = Math.max(parseInt(input.min, 10) || 0, val - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ─── Countdown Timer ─── */
  var countdownEl = $('#icevlt-countdown');
  if (countdownEl) {
    var endStr = countdownEl.getAttribute('data-end');
    var endDate = new Date(endStr).getTime();
    // If invalid or past, roll forward to a 2-day window
    if (isNaN(endDate) || endDate < Date.now()) {
      endDate = Date.now() + 2 * 24 * 60 * 60 * 1000;
    }
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
    var tick = function () {
      var diff = endDate - Date.now();
      if (diff < 0) diff = 0;
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var setTxt = function (id, val) { var el = $('#' + id); if (el) el.textContent = pad(val); };
      setTxt('cd-days', d); setTxt('cd-hours', h); setTxt('cd-minutes', m); setTxt('cd-seconds', s);
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ─── Order Timeline Dates ─── */
  var timeline = $('#product-timeline');
  if (timeline) {
    var fmt = function (d) {
      return d.toLocaleDateString('en-US', { day: 'numeric', month: 'short' });
    };
    var addDays = function (base, days) {
      var d = new Date(base); d.setDate(d.getDate() + days); return d;
    };
    var now = new Date();
    var dispatchDays = parseInt(timeline.getAttribute('data-dispatch-days'), 10) || 1;
    var delMin = parseInt(timeline.getAttribute('data-delivery-min'), 10) || 7;
    var delMax = parseInt(timeline.getAttribute('data-delivery-max'), 10) || 10;
    var setTL = function (id, txt) { var el = $('#' + id); if (el) el.textContent = txt; };
    setTL('tl-order', fmt(now));
    setTL('tl-dispatch', fmt(addDays(now, dispatchDays)));
    setTL('tl-deliver', fmt(addDays(now, delMin)) + ' - ' + fmt(addDays(now, delMax)));
  }

  /* ─── Init cart count on load ─── */
  fetchCart().then(function (cart) { updateCartCount(cart.item_count); }).catch(function () {});

})();
